<template>
  <div>
    <Filtro @filtro="makeFiltro"></Filtro>
    <vs-card>
      <List
        :filtro="filtro"
        :realizaFiltro="realizaFiltro"
        @filtroOk="finalizaFiltro"
        :subjectPermission="subjectPermission"
      ></List>
    </vs-card>
  </div>
</template>

<script>
import List from "./../../lists/ListPainelFinanceiro";
import Filtro from "./../../filtros/FiltroPainelFinanceiro";
export default {
  data() {
    return {
      realizaFiltro: false,
      filtro: null,
      subjectPermission: "Painel Financeiro",
    };
  },
  methods: {
    makeFiltro(filtro) {
      this.realizaFiltro = true;
      this.filtro = filtro;
    },
    finalizaFiltro() {
      this.realizaFiltro = false;
    },
  },
  components: {
    List,
    Filtro,
  },
};
</script>
